import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../../WorkoutTemplateBuilder'
import { Bars3BottomLeftIcon, ExclamationTriangleIcon, ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import { equipmentOptions } from 'functions/equipmentUtils'
import bodyweightIcon from 'media/icons/bodyweight.png'
import kinesisLogo from 'media/kinesis_logo.png'

export default function ExerciseCardDetailsButton({ phaseIndex, exercise, exerciseIndex }) {
    const { mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    return (
        <button onClick={() => mutateExercise('toggle-details', phaseIndex, exerciseIndex)} className="h-8 flex-grow px-2 flex items-center cursor-pointer">
            <div className="flex-grow flex items-center gap-x-1">
                {/* Exercise Index */}
                <p className="text-sm text-gray-500">{exerciseIndex + 1}. </p>

                {/* Exercise Name */}
                <div className="text-gray-800 text-sm">{exercise.name}</div>

                {/* If continuous override is false, display the exercise type icon */}
                {!exercise.continuousOverride && (
                    <>
                        {/* Recommendation Exercise Type Icon */}
                        {exercise.exerciseType === 'recommendation' && <img src={kinesisLogo} title="Kinesis" alt="Kinesis" className="h-3" />}

                        {/* Bodyweight Exercise Type Icon */}
                        {exercise.exerciseType === 'bodyweight' && <img src={bodyweightIcon} title="Bodyweight" alt="Bodyweight" className="h-3 text-stone-500" />}
                    </>
                )}

                {/* Continuous Override Icon */}
                {exercise.continuousOverride && <ExclamationTriangleIcon title="Exercise Note" className="h-3 text-stone-500" />}
            </div>

            {/* Progression Tag 
            {previousWeekWorkoutTemplateJSON !== null &&
                <>
                    {previousWeekWorkoutTemplateJSON.phases[phaseIndex].exercises[exerciseIndex].exerciseGenerationParameters.progressionLevel !== exercise.exerciseGenerationParameters.progressionLevel && 
                        <div className="text-sm text-white font-bold px-2 mr-2 rounded-lg bg-gradient-to-r from-orange-600 to-orange-400">
                            Progression!
                        </div>
                    }
                </>
            }
            */}

            {/* Exercise Note Icon */}
            {exercise.note !== '' && <Bars3BottomLeftIcon title="Exercise Note" className="h-3 text-stone-500" />}

            {/* Equipment Icons */}
            {/* Undefined check since mobility templates don't have exercises yet */}
            {exercise.equipment !== undefined && (
                <>
                    {exercise.equipment.length > 0 && equipmentOptions.find((option) => option.name === exercise.equipment) !== null && (
                        <div className="flex px-2 gap-x-2">
                            {exercise.equipment.split(',').map((text, index) => (
                                <img key={index} src={equipmentOptions.find((option) => option.key === text).imageURL} alt="Equipment Icon" className="h-6" />
                            ))}
                        </div>
                    )}
                </>
            )}

            {/* Chevron Down Icon */}
            {!exercise.showDetails && <ChevronDownIcon className="h-4 text-stone-600 pointer-events-none" />}

            {/* Chevron Up Icon */}
            {exercise.showDetails && <ChevronUpIcon className="h-4 text-stone-600 pointer-events-none" />}
        </button>
    )
}
